import { clsx } from "clsx";
import { type ReactNode } from "react";

type GridSkeletonProps = {
  rowsCount: number;
  columnsCount: number;
  renderItem?: (index: number) => ReactNode;
};

export const GridSkeleton = ({
  rowsCount,
  columnsCount,
  renderItem = (index: number) => (
    <GridSkeletonItem key={`grid-skeleton-item-${index}`} />
  )
}: GridSkeletonProps) => {
  return (
    <div
      className={clsx("grid gap-1", {
        "grid-cols-2": columnsCount === 2,
        "grid-cols-3": columnsCount === 3,
        "grid-cols-4": columnsCount === 4
      })}
    >
      {Array.from({ length: rowsCount * columnsCount }).map((_, index) =>
        renderItem(index)
      )}
    </div>
  );
};

type GridSkeletonItemProps = {
  className?: string;
};

export const GridSkeletonItem = ({ className }: GridSkeletonItemProps) => {
  return (
    <div
      className={clsx(
        "h-20 w-full animate-pulse rounded bg-interface-neutral-2 p-3 outline outline-1 outline-white",
        className
      )}
    />
  );
};
